module.exports = __webpack_public_path__ + "catalog/items/bedroom/wardrobe/wardrobe.svg";